export const iconFontAwesomeGamingDragon = (
	<i className="fa-solid fa-dragon"></i>
);
